export const storeKeyNameSpace = {
    INSTALL_APP: 'installApp',
    AUTH: 'auth',
    DASHBOARD: 'dashboard',
    CHARGE: 'charge',
    UPDATE_APP: 'updateApp',
    ACCOUNT_SETTINGS: 'accountSettings',
    OPTIMIZE_IMAGE: 'optimizeImage',
    PRELOADING: 'preloading',
    LOADING_SCREEN: 'loadingScreen',
    ONBOARDING: 'onboarding',
    SWIFT_EXPERT: 'swiftExpert',
    PROMOTION: 'promotion'
}
